import { compose } from 'redux'
import { connect } from 'react-redux'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { bindPromiseCreators } from '../../../utils/routines'
import '../../../utils/validations/extendYup'

import { withUpdateProfileSaga } from '../saga'
import { createUpdateProfilePromise } from '../routines'

// connect
export const mapDispatchToProps = bindPromiseCreators({
  update: createUpdateProfilePromise
})

const connector = connect(null, mapDispatchToProps)

// formik
export const mapPropsToValues = ({ userProfile }) => ({
  name: userProfile.public_data.name,
  lastname: userProfile.public_data.lastname,
  phone: userProfile.public_data.phone
})

export const validationSchema = yup.object().shape({
  name: yup.string().required(),
  lastname: yup.string().required(),
  phone: yup.string().phoneNumber().required()
})

export async function handleSubmit(values, { props, setStatus, setSubmitting }) {
  try {
    await props.update({ id: props.userProfile.id, ...values })
  } catch (error) {
    setStatus({ error })
  } finally {
    setSubmitting(false)
  }
}
const formik = withFormik({
  mapPropsToValues,
  validationSchema,
  handleSubmit
})

// enhancer
export default compose(
  withUpdateProfileSaga,
  connector,
  formik
)
